import { topicPicks } from '@/mocks/home';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function TopicPicks() {
  return (
    <section id="archive" className="w-full bg-background-50">
      <div className="mx-auto w-full px-4 py-8 md:px-6 md:py-10">
        <SectionHeading
          kicker="COLLECTIONS"
          title="专题精选"
          desc="把同类内容打包成可回看的合集，比零散翻找更省时间。"
          actionLabel="全部专题"
          actionHref="#archive"
        />

        <div className="grid grid-cols-1 gap-5 md:grid-cols-3 md:gap-6">
          {topicPicks.map((item) => (
            <article
              key={item.id}
              className="group overflow-hidden rounded-lg border border-background-200 bg-background-50"
            >
              <a href="#archive" className="block cursor-pointer">
                <div className="relative h-40 w-full overflow-hidden md:h-44">
                  <img
                    src={item.image}
                    alt={`${item.title}专题配图`}
                    title={`${item.tag} · ${item.title}`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute left-3 top-3 rounded-md bg-accent-500 px-2 py-0.5 text-[11px] font-bold text-accent-950">
                    {item.tag}
                  </span>
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-xs leading-relaxed text-foreground-600">{item.desc}</p>
                  <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
                    <span className="flex items-center gap-1.5 text-[11px] text-foreground-500">
                      <i className="ri-stack-line" aria-hidden="true"></i>
                      {item.count} 条内容
                    </span>
                    <span className="flex items-center gap-1 text-[11px] font-medium text-primary-600">
                      查看合集
                      <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
                    </span>
                  </div>
                </div>
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}